import type { SidePanelFooterProps } from "./side-panel-footer.type";

import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const SidePanelFooter = ({ children }: SidePanelFooterProps) => {
  const [domReady, setDomReady] = useState(false);

  // wait until the DOM is ready before creating portal
  useEffect(() => setDomReady(true));

  if (!domReady) return null;

  const container = document.getElementById("side-panel-footer-placeholder");

  return createPortal(children, container as HTMLElement);
};

export default SidePanelFooter;
